// @flow

import { observer } from "mobx-react";
import React from "react";

import User from "app/models/User";

import Panel from "app/components/Panel/Panel";
import PageTitle from "app/components/PageTitle/PageTitle";
import UserCards from "app/components/UserCards/UserCards";

type Props = {
    users: any[]
};

@observer
export default class AdminUsersView extends React.Component<Props> {
    users: User[];

    constructor(props: Props) {
        super(props);
        this.users = User.makeArray(this.props.users);
    }

    render() {
        return (
            <div className="AdminUsersView">
                <Panel>
                    <PageTitle>
                        <i className="fa fa-users" /> Users
                    </PageTitle>

                    <UserCards users={this.users} />
                </Panel>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app/admin/Users/AdminUsersView.js